export const getColumns = (props: any) => {
  if (props) {
    const { Model, PageData } = props;
    return [
      {
        key: 'date',
        value: PageData?.DateColumnHeader,
        isVisible: true,
        isSortable: true,
      },
      {
        key: 'transactionType',
        value: PageData?.TransactiontypeColumnHeader,
        isVisible: !!Model?.IsTransactionTypeColumnVisible,
        isSortable: true,
      },
      {
        key: 'amount',
        value: PageData?.PaymentamountColumnHeader,
        isVisible: true,
        isSortable: true,
      },
      {
        key: 'balance',
        value: PageData.NewbalanceColumnHeader,
        isVisible: !!Model?.IsBalanceColumnVisible,
        isSortable: true,
      },
      // {
      //   key: 'details',
      //   value: props.transactionHistoryTableHeaderMoreInfo?.value,
      //   isVisible: !!Model?.TransactionHistory?.IsDetailsColumnVisible,
      //   isSortable: false,
      // },
    ];
  }
  return undefined;
}